import type {
  BindingSecretsStored,
  InstanceBindingView,
  SecretPointer,
} from "@shared/types/instances";

/**
 * Whether a secret is stored, read from its pointer or, when the server withheld the pointer, from
 * its stored flag (SEC-17). The binding and settings GETs send the vault and secret names only to a
 * caller holding `instance.settings.write`; everyone else reads every pointer as null and a stored
 * flag beside it. So "is a secret stored" is never `pointer !== null` alone: use this everywhere.
 */
export function isSecretStored(pointer: SecretPointer, stored?: boolean): boolean {
  return pointer !== null || stored === true;
}

/** {@link isSecretStored} for one secret field of an instance binding. */
export function bindingSecretStored(
  binding: InstanceBindingView,
  field: keyof BindingSecretsStored,
): boolean {
  return isSecretStored(binding[field], binding.secretsStored?.[field]);
}
